import angular from 'angular';
import modalCancelDelegationComponent from './modalCancelDelegation.component';

let modalCancelDelegationModule = angular.module('modalCancelDelegation', [])

.component('modalCancelDelegation', modalCancelDelegationComponent)

.name;

export default modalCancelDelegationModule;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalCancelDelegation/modalCancelDelegation.js